/**
 * BDOEX API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * Contact: mateusz.surma@mae.pl
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * WasteRegisterPublicApiApiModelsRequestsWasteRegisterWasteTransferCardV1PlanKpoRequest
 */
export interface WasteRegisterPublicApiApiModelsRequestsWasteRegisterWasteTransferCardV1PlanKpoRequest { 
    /**
     * Id podmiotu transportującego odpady
     */
    carrierCompanyId?: string;
    /**
     * Id podmiotu przejmującego odpady
     */
    receiverCompanyId?: string;
    /**
     * Id miejsca prowadzenia działalności podmiotu przejmującego odpady
     */
    receiverEupId?: string;
    /**
     * Id kodu odpadu
     */
    wasteCodeId?: number;
    /**
     * Numer rejestracyjny środka transportu
     */
    vehicleRegNumber?: string;
    /**
     * Masa odpadów
     */
    wasteMass?: number;
    /**
     * Data i godzina rozpoczęcia transportu
     */
    plannedTransportTime?: Date;
    /**
     * Id rodzaju procesu przetwarzania
     */
    wasteProcessId?: number;
    /**
     * Numer certyfikatu oraz numery pojemników
     */
    certificateNumberAndBoxNumbers?: string;
    /**
     * Informacje dodatkowe
     */
    additionalInfo?: string;
    /**
     * Kod ex
     */
    wasteCodeExtended?: boolean;
    /**
     * Rodzaj odpadu ex
     */
    wasteCodeExtendedDescription?: string;
    /**
     * Zmiana statusu odpadów niebezpiecznych na odpady inne niż niebezpieczne
     */
    hazardousWasteReclassification?: boolean;
    /**
     * Rodzaj odpadu
     */
    hazardousWasteReclassificationDescription?: string;
    /**
     * Gets or Sets IsWasteGenerating
     */
    isWasteGenerating?: boolean;
    /**
     * Gets or Sets WasteGeneratedTerytPk
     */
    wasteGeneratedTerytPk?: string;
    /**
     * Gets or Sets WasteGeneratingAdditionalInfo
     */
    wasteGeneratingAdditionalInfo?: string;
}